module.exports = "/static/assets/05f303cf5e0d682448fd86af2b820d27.png";